var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6924",
    "data-name": "Grupo 6924",
    transform: "translate(-24 -288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3570",
    "data-name": "Grupo 3570",
    transform: "translate(9937 -1244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "groups_black_24dp",
    transform: "translate(-9913 1533)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2062",
    "data-name": "Rect\\xE1ngulo 2062",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2508",
    "data-name": "Grupo 2508",
    transform: "translate(-2.623 3.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3909",
    "data-name": "Trazado 3909",
    d: "M14.623,15.7a15.25,15.25,0,0,1,6.094,1.293,4.289,4.289,0,0,1,2.529,3.923v2.328H6V20.932a4.259,4.259,0,0,1,2.529-3.923A15,15,0,0,1,14.623,15.7Zm0-9.7a4.312,4.312,0,1,1-4.312,4.312A4.306,4.306,0,0,1,14.623,6Z",
    transform: "translate(0 -6)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_224",
    "data-name": "Elipse 224",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(42 288)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.2c61419cab3c4653313c2045664c4ea7.svg";
export { ForwardRef as ReactComponent };